import TabContentLoading from 'components/molecules/TabContentLoading';
import { FC } from 'react';

const ClientCustomizationLoadingTemplate: FC = () => {
  return (
    <TabContentLoading />
  );
}

export default ClientCustomizationLoadingTemplate;